import { isNotNull } from '@grandvisionhq/utils';

const isPowerAttribute = (attr)=>{
    return attr.name === 'power';
};
const findPowerAttribute = (variant)=>{
    var ref;
    return variant === null || variant === void 0 ? void 0 : (ref = variant.attributes) === null || ref === void 0 ? void 0 : ref.find(isPowerAttribute);
};
const mapVariantPowerItems = (variants)=>variants.map((variant)=>{
        const powerAttribute = findPowerAttribute(variant);
        var _sku;
        return powerAttribute ? {
            value: (_sku = variant.sku) !== null && _sku !== void 0 ? _sku : '',
            label: powerAttribute.value
        } : null;
    }).filter(isNotNull)
;
const getSortedPowerItems = (mappedItems)=>mappedItems.sort((a, b)=>+a.label - +b.label
    )
;

export { findPowerAttribute, getSortedPowerItems, isPowerAttribute, mapVariantPowerItems };
//# sourceMappingURL=utils.js.map
